import { array, boolean, mixed, object, string } from 'yup';

import { Honorific, TemplateEntryType } from '../../../data/types/api/graphql';
import { parseTimeToMinutes } from '../../../data/utils/date.utils';
import { messages, nanNumber, trim } from '../../../data/utils/form.utils';

const entrySchema = {
  id: string().transform(trim).required(messages.required.id).default(''),
  name: string().transform(trim).required(messages.required.id).default(''),
  minuteStartTime: string()
    .transform(trim)
    .required(messages.required.id)
    .default(''),
  minuteEndTime: string()
    .transform(trim)
    .test('end-time', messages.invalidEndTime.id, function t(value) {
      const { minuteStartTime } = this.parent;
      if (!minuteStartTime || !value) return true;
      const start = parseTimeToMinutes(minuteStartTime);
      const end = parseTimeToMinutes(value);
      if (start === null || end === null) return false;
      return end > start;
    })
    .required(messages.required.id)
    .default(''),
  minuteLength: nanNumber().required(messages.required.id).default(15),
};

export const schema = object()
  .shape({
    name: string().transform(trim).required(messages.required.id).default(''),
    honorific: mixed<Honorific>().oneOf(Object.values(Honorific)).nullable(),
    overwrite: boolean().nullable().default(false),
    entries: array(
      object().shape({
        ...entrySchema,
        type: mixed<TemplateEntryType>()
          .oneOf(Object.values(TemplateEntryType))
          .required(messages.required.id)
          .default(TemplateEntryType.AppointmentBlock),
        appointments: array(
          object().shape({
            ...entrySchema,
            type: mixed<TemplateEntryType>()
              .oneOf(Object.values(TemplateEntryType))
              .required(messages.required.id)
              .default(TemplateEntryType.Exception),
          })
        ).default([]),
      })
    ).default([]),
  })
  .required()
  .noUnknown();
